import React from 'react'
import Omega from './PricesSection.omega'
import Reize from './PricesSection.reize'
import Jaikudo from './PricesSection.jaikudo'
import { SwitchByAppType } from '../..'

const variants = {
  Omega,
  Reize,
  Jaikudo,
}

export default props => <SwitchByAppType variants={variants} props={props} />
